import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { UiRights } from '../../generated/types';
import { AdminUiRights } from '@onep/front-portal-lib';

export interface AdminManagementService {
  getUserAdminRights(): Observable<AdminUiRights>;
}

export const IS_ADMIN_MANAGEMENT_SERVICE =
  new InjectionToken<AdminManagementService>('IS_ADMIN_MANAGEMENT_SERVICE');
